/**
 * Lazy loading implementation for images and videos using Intersection Observer API
 * Handles both mobile and desktop versions of media files
 */
document.addEventListener( "DOMContentLoaded", function () {
  const lazyElements = document.querySelectorAll( '.lazy' );

  if ( lazyElements.length === 0 ) {
    return;
  }

  // Detect if user is on mobile device or viewport width is mobile
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test( navigator.userAgent ) || window.innerWidth <= 768;

  // Initialize intersection observer to detect when elements enter viewport
  const lazyLoadObserver = new IntersectionObserver( ( entries, observer ) => {
    entries.forEach( entry => {
      if ( entry.isIntersecting ) {
        const element = entry.target;

        // Handle different media types
        if ( element.tagName.toLowerCase() === 'img' ) {
          handleLazyImage( element, isMobile );
        } else if ( element.tagName.toLowerCase() === 'video' ) {
          handleLazyVideo( element, isMobile );
        }

        element.classList.remove( 'lazy' );
        observer.unobserve( element );
      }
    } );
  }, {
    rootMargin: '400px 0px',
    threshold: 0.01 // Trigger when even 1% of element is visible
  } );

  /**
   * Handles lazy loading for images
   * @param {HTMLImageElement} img - Image element to be lazy loaded
   * @param {boolean} isMobile - Whether mobile version should be loaded
   */
  function handleLazyImage( img, isMobile ) {
    if ( img.dataset.srcMobile && img.dataset.srcDesktop ) {
      img.src = isMobile ? img.dataset.srcMobile : img.dataset.srcDesktop;
    } else if ( img.dataset.src ) {
      img.src = img.dataset.src;
    }
    if ( img.dataset.srcset ) {
      img.srcset = img.dataset.srcset;
    }
    if ( img.dataset.sizes ) {
      img.sizes = img.dataset.sizes;
    }

    [ 'src', 'src-mobile', 'src-desktop', 'srcset', 'sizes' ].forEach( key => {
      img.removeAttribute( 'data-' + key );
    } );
  }

  /**
   * Handles lazy loading for videos
   * @param {HTMLVideoElement} video - Video element to be lazy loaded
   * @param {boolean} isMobile - Whether mobile version should be loaded
   */
  function handleLazyVideo( video, isMobile ) {
    const autoplay = video.dataset.autoplay === 'true';
    let src,
      type;
    if ( video.dataset.srcMobile && video.dataset.srcDesktop ) {
      src = isMobile ? video.dataset.srcMobile : video.dataset.srcDesktop;
      type = isMobile ? video.dataset.typeMobile || 'video/mp4' : video.dataset.typeDesktop || 'video/mp4';
    } else if ( video.dataset.src ) {
      src = video.dataset.src;
      type = video.dataset.type || 'video/mp4';
    }

    if ( src ) {
      const source = document.createElement( 'source' );
      source.src = src;
      source.type = type;

      while ( video.firstChild ) video.removeChild( video.firstChild );

      video.appendChild( source );

      if ( autoplay ) {
        video.muted = true;
        video.playsInline = true;
        video.setAttribute( 'playsinline', '' );
        video.setAttribute( 'muted', '' );
      }

      video.load();
    }
    if ( video.dataset.poster ) {
      video.poster = video.dataset.poster;
      video.removeAttribute( 'data-poster' );
    }

    [ 'src', 'src-mobile', 'src-desktop', 'type', 'type-mobile', 'type-desktop', 'autoplay' ].forEach( key => {
      video.removeAttribute( 'data-' + key );
    } );

    if ( autoplay ) {
      const playPromise = video.play();
      if ( playPromise !== undefined ) {
        playPromise.catch( e => console.log( "Autoplay prevented:", e ) );
      }
    }
  }

  // Start observing all lazy elements
  lazyElements.forEach( element => {
    lazyLoadObserver.observe( element );
  } );

} );
